import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import WebsolutionsSidebar from '../../../components/WebsolutionsSidebar'
import BranddevelopmentSidebar from '../../../components/BranddevelopmentSidebar'
import DigitalmarketingSidebar from '../../../components/DigitalmarketingSidebar'

import Fill from '../../../images/Fill.svg'
import Divider from '../../../images/Divider.svg'

export const query = graphql`
  query googlemarketing {
    gmbanner: imageSharp(id: {regex: "/images/Thor.jpg/"}) {
      sizes(quality: 75, maxWidth: 1000, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
}
`

const GoogleMarketing = ({data:{gmbanner}}) => (
  <section>
    <article className='container'>
    <div className='full-Width' style={{alignItems:'flex-start'}}>
      <div className='half-Width-75 paddingRight mobBottommargin'>
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Google Marketing</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
          <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
          <p>See how businesses similar to yours are growing with Digital Marketing.</p>
          <div style={{backgroundImage:`url("${gmbanner.sizes.src}"), url("${gmbanner.sizes.tracedSVG}")`, backgroundPosition:'center', backgroundSize:'cover', minHeight:'50vh', marginBottom:'1.45rem'}}>
          </div>
          <p>Search Ads (PPC): We use Search Ads to make sure that potential customers/audience notice your brand, consider your services and take action. When you set up a search ad, you can increase your online sales,
          get more leads and drive traffic to your website. With Pay Per Click (PPC) search ads, you only pay when customers click your ad to visit or call your business.</p>
          <p>Display Ads (Banners): We use images or rich media in this customized layout including interactive elements, animations and many more on other websites to promote and increase your brand
          awareness to potential customers browsing online, checking their mails or using mobile devices and apps.</p>
          <p style={{marginBottom:'0'}}>Video Ads (YouTube skip ad): We promote your brand and services using skip-able videos in YouTube to potential audience who are watching or browsing videos on YouTube.
          Video ads broaden your brand’s awareness by catching attention and driving demand at scale.</p>
        </div>
      </div>
      <div className='half-Width-25 service-sidebar'>
        <div style={{marginBottom:'2.5rem'}}><DigitalmarketingSidebar /></div>
        <div style={{marginBottom:'2.5rem'}}><WebsolutionsSidebar /></div>
        <div><BranddevelopmentSidebar /></div>
      </div>
    </div>
    </article>
  </section>
)

export default GoogleMarketing



// WEBPACK FOOTER //
// ./src/pages/services/digital-marketing/google-marketing.js